import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Link as MuiLink,
  Divider,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import authService from "../../services/auth.service";
import "../../styles/components.css";
import toast from "react-hot-toast";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await authService.register(formData.email, formData.password, formData.name);
      toast.success(res.message);
      navigate("/login");
    } catch (err) {
      toast.error(err);
      setError(err || "Failed to register");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-page-container">
      <Grid container height={"100vh"}>
        <Grid item xs={12} sm={12} md={5}>
          <div className="login-page-image-container" />
        </Grid>

        <Grid item xs={12} sm={12} md={7}>
          <Container className="right-panel-auth">
            <Box
              className="auth-box"
              sx={{
                maxWidth: isMobile ? "100%" : "85%",
              }}
            >
              <Typography className="auth-heading">
                Instant access to trading from comfort of your home
              </Typography>

              <Typography sx={{ my: 3, fontSize: 32, fontWeight: 700 }}>
                Sign Up
              </Typography>

              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  {error}
                </Alert>
              )}

              <Box
                component="form"
                onSubmit={handleSubmit}
                className="auth-form-box"
              >
                <Box >
                  <Typography sx={{ fontSize: 24, fontWeight: 500 }}>
                    Email
                  </Typography>
                  <TextField
                    fullWidth
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    hiddenLabel
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "20px 16px",
                        fontSize: "20px",
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography sx={{ fontSize: 24, fontWeight: 500 }}>
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    hiddenLabel
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "20px 16px",
                        fontSize: "20px",
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography sx={{ fontSize: 24, fontWeight: 500 }}>
                    Password
                  </Typography>
                  <TextField
                    fullWidth
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    hiddenLabel
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "20px 16px",
                        fontSize: "20px",
                      },
                    }}
                  />
                </Box>

                <Button
                  sx={{
                    mt: 3,
                  }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  size="large"
                  className="button-primary"
                  loading={loading}
                  loadingPosition="end"
                >
                  Sign Up
                </Button>

                <Box className="auth-divider">
                  <Divider className="or-divider" />
                  <Typography variant="body2" className="auth-divider-text">
                    Or
                  </Typography>
                </Box>

                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    component="span"
                    sx={{ fontSize: 16, fontWeight: 400 }}
                  >
                    Already have an account?{" "}
                    <MuiLink
                      component={Link}
                      to="/login"
                      className="signup-link"
                    >
                      Sign In
                    </MuiLink>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Register;
